




















































import { Component, Vue, Prop } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import GlobalMixins from "@/global.mixin";

@Component({
  mixins: [GlobalMixins],
  components: { }
})
export default class PrintLabelView extends Vue {

    @Prop({ type: Boolean, default: false }) value!: boolean;

    @State("socketState") socketState: any;
    // @State("printLabel") printLabel: any;
    @Action("removeFromPrint") removeFromPrint: any;
    @Action("clearPrintQueue") clearPrintQueue: any;
    @Action("printMultipleLabels") printMultipleLabels: any;

    isDragging = false;
    dragOffset = { x: 0, y: 0 };
    cardPosition = { x: 50, y: 0 };

    get dialog() {
      return this.value;
    }

    set dialog(value) {
      this.$emit("input", value);
      if (value) {
        this.setInitialPosition();
      }
    }

    get cardStyle() {
      return {
        position: "fixed",
        left: this.cardPosition.x + "px",
        top: this.cardPosition.y + "px",
        zIndex: 1000,
        transition: this.isDragging ? "none" : "none"
      };
    }

    closeDialog() {
      this.dialog = false;
    }

    setInitialPosition() {
      // Position in left bottom corner
      this.cardPosition.x = 50;
      this.cardPosition.y = window.innerHeight - 450; // Position near bottom with some margin
    }

    removeLabel(labelItem) {
      this.removeFromPrint({
        id: labelItem.barCode,
        idKey: "barCode"
      });
    }

    clearAllLabels() {
      this.clearPrintQueue();
    }

    printAllLabels() {
      this.printMultipleLabels();
    }

    startDrag(event) {
      this.isDragging = true;
      this.dragOffset.x = event.clientX - this.cardPosition.x;
      this.dragOffset.y = event.clientY - this.cardPosition.y;

      document.addEventListener("mousemove", this.onMouseMove);
      document.addEventListener("mouseup", this.onMouseUp);
      event.preventDefault();
      event.stopPropagation();
    }

    onMouseMove(event) {
      if (this.isDragging) {
        // Calculate new position based on mouse movement
        const newX = event.clientX - this.dragOffset.x;
        const newY = event.clientY - this.dragOffset.y;

        // Apply constraints
        this.cardPosition.x = Math.max(0, Math.min(newX, window.innerWidth - 300));
        this.cardPosition.y = Math.max(0, Math.min(newY, window.innerHeight - 200));
      }
    }

    onMouseUp(event) {
      if (this.isDragging) {
        this.isDragging = false;
        document.removeEventListener("mousemove", this.onMouseMove);
        document.removeEventListener("mouseup", this.onMouseUp);
      }
    }

    getLabelHeaders() {
      return [
        { text: "Címke", value: "label", width: "80%", align: "left" },
        { text: "Törlés", value: "actions", width: "20%", align: "left", sortable: false }
      ];
    }

    mounted() {
      this.setInitialPosition();
    }

    beforeDestroy() {
      document.removeEventListener("mousemove", this.onMouseMove);
      document.removeEventListener("mouseup", this.onMouseUp);
    }
}
